import {NavLink} from "react-router-dom"
import {Animate} from "react-simple-animate";
import 'remixicon/fonts/remixicon.css'


//redux functions
import {
    setWatchIsActive,
    setReadIsActive,
    setLearnIsActive,
    setFavouritesIsActive
} from "../../Features/Misc/navBarSlice"
import {useDispatch, useSelector} from "react-redux";

//components
import UserOffCanvas from "../structure/UserOffcanvas/UserOffCanvas";
import SearchBar from "./SearchBar";
import MiniNav from "./MiniNav";
import {activeMediaReset} from "../../Features/Misc/activeSlice";


export default function Navbar(props) {

    const dispatch = useDispatch();


    //redux
    const {watchIsActive, readIsActive, learnIsActive, favouritesIsActive} = useSelector((state) => state.navBar)
    const {landingIsActive} = useSelector((state) => state.active)


    const navWidth = (landingIsActive ? " 3xl:col-start-1 " : " 3xl:col-start-7 ")
    const navRows = (landingIsActive ? " row-start-1 row-end-2 py-8  " : " row-start-1 row-end-3 ")
    const navClassesBase = (navRows + "Navbar w-full text-white grid grid-rows-2 text-white  px-6 rounded-b-lg ")
    const navClassesMob = " text-xl "
    const navClassesSmall = (landingIsActive ? " sm:col-start-1 " : "sm:col-start-8 ") + " sm:col-end-25 sm:text-2xl "
    const navClassesLarge = " lg:grid"
    const navClassesMega = (navWidth + " 3xl:col-end-25 3xl:px-6 3xl:text-1.5xl")
    const dashboardText = (landingIsActive ? "" : "Dashboard")
    const navColor = (landingIsActive ? " bg-purple-slumber " : "bg-purple-dashboard")

    const handleClick = () => {
        dispatch(setWatchIsActive())
        dispatch(activeMediaReset())
    }


    return (
        <>
            <nav
                className={` ${navClassesMob} ${navClassesBase} ${navClassesSmall} ${navClassesLarge} ${navClassesMega} ${navColor}  hidden `}>

                <ul className="flex items-center row-span-1 list-none justify-between mt-4 gap-4">
                    <li onClick={handleClick} className={`${!landingIsActive ? " hidden " : " "}`}>
                        <Animate
                            play
                            start={{opacity: 0}}
                            end={{opacity: 1}}
                            duration={0.7}
                        >
                            <img className="w-32" src="https://www.kipmate.com/sortyourkip/client/build/kmlogo.svg"
                                 alt=""/>
                        </Animate>
                    </li>

                    <li className="3xl:text-2xl 3xl:mr-64 w-64" onClick={handleClick}>
                        <Animate play start={{opacity: 0}} end={{opacity: 1}} duration={0.7}>
                            <NavLink to="/">{dashboardText}</NavLink>
                        </Animate>
                    </li>

                    <li className="flex flex-row gap-4 items-center">
                        <Animate play start={{opacity: 0}} end={{opacity: 1}} duration={0.7}>
                            <SearchBar width={"w-60 md:w-80 "}/>
                        </Animate>

                        <Animate play start={{opacity: 0}} end={{opacity: 1}} duration={0.7}>
                            <UserOffCanvas customHeight={` h-10 sm:h-10 `} customWidth={` w-10 sm:w-10 `}
                                           customMinWidth={` min-w-10 sm:min-w-10 `}/>
                        </Animate>
                    </li>
                </ul>


                {!landingIsActive &&
                    <ul className="flex row-span-1 list-none space-x-10 items-center">
                        <li className={watchIsActive ? "bg-gold-accent p-2.5 rounded-lg duration-300 transition-background-color"  : "p-2.5 hover:opacity-60 transition-opacity duration-300 transition-background-color"}>
                            <button className="flex items-center" onClick={() => dispatch(setWatchIsActive())}>
                                {/*<img height="16" width="16" src="../../assets/lock-unlock-line.svg" />*/}
                                <i className="ri-video-line mr-4  text-pink-icon"></i> Videos

                            </button>
                        </li>
                        <li className={readIsActive ? "bg-gold-accent p-2.5 rounded-lg duration-300 transition-background-color" : "p-2.5 hover:opacity-60 transition-opacity duration-300 transition-background-color"}>
                            <button className="flex items-center" onClick={() => dispatch(setReadIsActive())}>
                                <i className="ri-book-read-line mr-2 3xl:mr-4  text-pink-icon"></i>Read
                            </button>
                        </li>
                        <li className={learnIsActive ? "bg-gold-accent p-2.5 rounded-lg duration-300 transition-background-color" : "p-2.5 hover:opacity-60 transition-opacity duration-300 transition-background-color"}>
                            <button className="flex items-center" onClick={() => dispatch(setLearnIsActive())}>
                                <i className="ri-lightbulb-line mr-2 3xl:mr-4  text-pink-icon "></i>Webinars
                            </button>
                        </li>
                        <li className={favouritesIsActive ? "bg-gold-accent p-2.5 rounded-lg duration-300 transition-background-color" : "p-2.5 hover:opacity-60 transition-opacity duration-300 transition-background-color"}>
                            <button className="flex items-center" onClick={() => dispatch(setFavouritesIsActive())}>
                                <i className="ri-heart-2-line mr-2 3xl:mr-4  text-pink-icon"></i>Favourites
                            </button>
                        </li>
                    </ul>
                }
            </nav>

            <MiniNav/>
        </>

    );
}

